import {
  useOrganizationId,
  useOrganizationLimits,
  useSubscription,
} from '~publish/contexts/AccountContext'
import { usePostCounts } from '~publish/pages/AllChannels/PostList/usePostCounts'
import { useSelectedChannel } from '~publish/pages/Channel/ChannelContext'

export function useChannelPostLimits(): {
  isFreePlan: boolean
  postLimit: number
  numberOfScheduledPosts: number
  limitReached: boolean
  postsRemaining: number
} {
  const organizationId = useOrganizationId() ?? ''
  const selectedChannel = useSelectedChannel()
  const selectedChannelId = selectedChannel?.id
  const { counts } = usePostCounts({
    organizationId,
    channelIds: selectedChannelId ? [selectedChannelId] : undefined,
  })
  const numberOfScheduledPosts = counts?.queue ?? 0
  const orgLimits = useOrganizationLimits()
  const postLimit = orgLimits?.scheduledPosts ?? 10
  const subscription = useSubscription()
  const isFreePlan = subscription?.plan?.id === 'free'

  return {
    isFreePlan,
    postLimit,
    numberOfScheduledPosts,
    limitReached: numberOfScheduledPosts >= postLimit,
    postsRemaining: postLimit - numberOfScheduledPosts,
  }
}
